export function printShippingLabel(order) {
  const shortId = order.id.substring(0, 8).toUpperCase();
  const toLines = [
    order.customer_name,
    order.address,
    [order.city, order.state].filter(Boolean).join(', '),
    order.pincode ? `${order.pincode}` : null,
    order.customer_phone ? `M: ${order.customer_phone}` : null,
  ].filter(Boolean);

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Shipping Label — #${shortId}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Segoe UI',Arial,sans-serif;background:#fff;padding:32px}
  .label{width:100%;border:3px solid #000;border-radius:6px;overflow:hidden;font-size:16px}
  .label-body{padding:22px 28px}
  .section{margin-bottom:18px}
  .section-title{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:#000;margin-bottom:8px;border-bottom:1.5px solid #ddd;padding-bottom:4px}
  .address-line{font-size:17px;color:#111;line-height:1.75}
  .divider{border:none;border-top:2px dashed #aaa;margin:16px 0}
  @media print{
    body{padding:0}
    .label{border-radius:0}
    @page{size:A4 portrait;margin:15mm}
  }
</style>
</head>
<body>
<div style="width:100%;height:45vh;display:flex;align-items:flex-start;">
  <div class="label" style="height:fit-content;">
    <div class="label-body">

      <div class="section">
        <div class="section-title">To</div>
        ${toLines.map((l, i) => `<div class="address-line"${i === 0 ? ' style="font-weight:700;"' : ''}>${l}</div>`).join('')}
      </div>

      <hr class="divider">

      <div class="section" style="margin-bottom:4px;">
        <div class="section-title">From</div>
        <div class="address-line" style="font-size:14px;font-weight:700;">Kiane Foods</div>
        <div class="address-line" style="font-size:11px;">Shop No. 15, Old Grain Market, Maur, Bathinda — 151509, Punjab</div>
        <div class="address-line" style="font-size:11px;">M: +91 8968246680</div>
      </div>

    </div>
  </div>
</div>
<script>window.onload=function(){window.print()}</script>
</body>
</html>`;

  const win = window.open('', '_blank');
  if (win) { win.document.write(html); win.document.close(); }
}
